import { Component } from '@angular/core';
import { CurrencyService } from '../../../../shared/services/currency.service';
import { CartService } from 'src/app/shared/services/cart.service';
import { UserService } from 'src/app/shared/services/user.service';
import { CountryInfo } from 'src/app/shared/interfaces/product';
import { StoreService } from 'src/app/shared/services/store.service';
import { SiteLanguageService } from 'src/app/shared/services/site-language.service';
import { SiteTranslation } from 'src/app/shared/interfaces/site-page';
import { Router } from '@angular/router';
import { CultureService } from 'src/app/shared/culture/culture.service';
import { rememberLanguage } from 'src/app/shared/culture/culture-switch.component';

@Component({
    selector: 'app-header-topbar',
    templateUrl: './topbar.component.html'
})
export class TopbarComponent {
    countryInfo:CountryInfo;

    /// The versions of the page on screen (SiteLanguageService), for the language switch.
    private translations: SiteTranslation[] = [];

    isLoggedIn:boolean;
    isOwner:boolean;

    constructor(
        public currencyService: CurrencyService, private culture:StoreService, private userService:UserService,
        private languages: SiteLanguageService, private cultures: CultureService, private router: Router
    )
    {
        this.languages.translations$.subscribe(translations => this.translations = translations);

        // Not the guess made before Locale/me answers (Pending): the flag's place stays empty until the visitor's own.
        this.culture.onCountry.subscribe(res =>
        {
            if(res && res.CurrencyMultiplier > 0 && !res.Pending){
                this.countryInfo = res;
            }
        });

        this.userService.onUserInfoChanged$.subscribe(res => {
            this.isLoggedIn = this.userService.isLoggedIn();
            // Owner-only entries in the account menu. The pages behind them are gated
            // server-side too, so this only decides whether the link is worth showing.
            this.isOwner = this.userService.isNijera() === true;
            // A seller (or their staff), decided as the console decides it: an approved shop with its own id.
            const sid = Number(((this.userService.uinfo || {}) as any).SID || 0);
            this.isSeller = !this.isOwner && this.userService.userType() === this.userService.userTypeConst.shop && sid > 0 && sid !== 786;
            const id = String((res && res.Id) || '');
            this.productsUrl = '/account/userproducts/' + id.replace(/-/g, '');
        });
    }

    /// The signed-in account is a seller's: the menu offers their console, not a shopper's pages (the owner, 2026-11-02).
    isSeller = false;
    productsUrl = '/account/userproducts';

    /// The switch to the other language: on an English page "বাংলা", on a Bangla page "English". A click sets the visitor's
    /// language (the culture cookie) and loads the page again at its address without a prefix - every address without one
    /// is shown in the chosen language. Only a version at another address (a post written in Bangla under its own slug) is
    /// gone to instead; a post with no version in English goes to the home page.
    get languageSwitch(): { label: string, url: string, lang: string } {
        const to = this.languages.lang === 'bn' ? 'en' : 'bn';
        const here = this.cultures.urlIn(to, this.router.url);
        const version = this.translations.filter(t => t.language === to)[0];
        const elsewhere = version && this.cultures.bare(version.path) !== this.cultures.bare(this.router.url.split(/[?#]/)[0]);
        const url = elsewhere ? version.path
            : !version && this.translations.length > 0 && to === 'en' ? '/'
            : here;
        return to === 'bn'
            ? { label: 'বাংলা', url, lang: 'bn' }
            : { label: 'English', url, lang: 'en' };
    }

    /// The visitor picked a language: kept for their emails (the page they go to is the link's).
    chooseLanguage(code: string): void {
        rememberLanguage(document, code);
    }
}
